export class RegExpValidationRule {
    name = 'regexp';
    validate(field, rule, value, object) {
        //vars
        let tMessage = 'This is no a valid value';
        let tExpression = rule.props.pattern;
        let tRegExp = new RegExp(tExpression);
        //Message
        if (rule.message) {
            tMessage = utils.format(rule.message, field.displayName);
        }
        //Rule
        if (value === undefined || value === null) {
            return {
                isValid: true
            };
        }
        if (!tRegExp.test(value)) {
            return {
                isValid: false,
                message: tMessage
            };
        }
        return {
            isValid: true
        };
    }
}
